import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Button, Card, Heading, Stack, Text } from "@/components/ds";
import { usePageTitle } from "../hooks/usePageTitle";

interface SuspendedPageProps {
  readonly reason: string | null;
}

export function SuspendedPage({ reason }: SuspendedPageProps) {
  usePageTitle("Account paused · TidyRota");
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    document.body.style.background = "var(--color-bg-subtle)";
    return () => {
      document.body.style.background = "";
    };
  }, []);

  async function handleLogout() {
    setLoggingOut(true);
    try {
      await fetch("/api/auth/logout", { method: "POST" });
    } finally {
      navigate("/login", { replace: true });
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--space-6)",
      }}
    >
      <div style={{ maxWidth: 480, width: "100%" }}>
        <Card padding="lg">
          <Stack gap={5}>
            <Stack gap={2}>
              <Heading level={1} size="h3">Your account is paused</Heading>
              <Text color="secondary">
                TidyRota is temporarily unavailable for your team. Please reach
                out so we can sort this out together.
              </Text>
            </Stack>

            {reason ? (
              <div
                style={{
                  background: "var(--color-bg-subtle)",
                  borderRadius: "var(--radius-md)",
                  padding: "var(--space-3)",
                }}
              >
                <Text size="sm" color="muted">Note from TidyRota</Text>
                <Text>{reason}</Text>
              </div>
            ) : null}

            <Stack gap={3}>
              <Button href="mailto:hello@tidyrota.com" variant="primary" fullWidth>
                Email us at hello@tidyrota.com
              </Button>
              <Button onClick={handleLogout} variant="ghost" fullWidth disabled={loggingOut}>
                {loggingOut ? "Signing out…" : "Sign out"}
              </Button>
            </Stack>
          </Stack>
        </Card>
      </div>
    </div>
  );
}
